var cov_183vvehy76 = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Popover/Panel.tsx",
      hash = "fa3c3360389c208c05c1706ddf788d979afd15be",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Popover/Panel.tsx",
    statementMap: {
      "0": {
        start: {
          line: 19,
          column: 20
        },
        end: {
          line: 19,
          column: 91
        }
      },
      "1": {
        start: {
          line: 19,
          column: 72
        },
        end: {
          line: 19,
          column: 91
        }
      },
      "2": {
        start: {
          line: 25,
          column: 26
        },
        end: {
          line: 32,
          column: 1
        }
      },
      "3": {
        start: {
          line: 54,
          column: 4
        },
        end: {
          line: 54,
          column: 16
        }
      },
      "4": {
        start: {
          line: 56,
          column: 4
        },
        end: {
          line: 56,
          column: 56
        }
      },
      "5": {
        start: {
          line: 57,
          column: 4
        },
        end: {
          line: 57,
          column: 27
        }
      },
      "6": {
        start: {
          line: 58,
          column: 4
        },
        end: {
          line: 58,
          column: 19
        }
      },
      "7": {
        start: {
          line: 59,
          column: 4
        },
        end: {
          line: 59,
          column: 38
        }
      },
      "8": {
        start: {
          line: 60,
          column: 4
        },
        end: {
          line: 60,
          column: 56
        }
      },
      "9": {
        start: {
          line: 61,
          column: 4
        },
        end: {
          line: 61,
          column: 46
        }
      },
      "10": {
        start: {
          line: 62,
          column: 4
        },
        end: {
          line: 62,
          column: 48
        }
      },
      "11": {
        start: {
          line: 63,
          column: 4
        },
        end: {
          line: 63,
          column: 48
        }
      },
      "12": {
        start: {
          line: 64,
          column: 4
        },
        end: {
          line: 64,
          column: 42
        }
      },
      "13": {
        start: {
          line: 65,
          column: 4
        },
        end: {
          line: 65,
          column: 46
        }
      },
      "14": {
        start: {
          line: 66,
          column: 4
        },
        end: {
          line: 66,
          column: 52
        }
      },
      "15": {
        start: {
          line: 67,
          column: 4
        },
        end: {
          line: 67,
          column: 58
        }
      },
      "16": {
        start: {
          line: 69,
          column: 4
        },
        end: {
          line: 69,
          column: 48
        }
      },
      "17": {
        start: {
          line: 73,
          column: 4
        },
        end: {
          line: 73,
          column: 29
        }
      },
      "18": {
        start: {
          line: 75,
          column: 26
        },
        end: {
          line: 75,
          column: 36
        }
      },
      "19": {
        start: {
          line: 76,
          column: 4
        },
        end: {
          line: 76,
          column: 37
        }
      },
      "20": {
        start: {
          line: 76,
          column: 19
        },
        end: {
          line: 76,
          column: 37
        }
      },
      "21": {
        start: {
          line: 78,
          column: 4
        },
        end: {
          line: 78,
          column: 56
        }
      },
      "22": {
        start: {
          line: 79,
          column: 4
        },
        end: {
          line: 79,
          column: 21
        }
      },
      "23": {
        start: {
          line: 81,
          column: 4
        },
        end: {
          line: 84,
          column: 5
        }
      },
      "24": {
        start: {
          line: 82,
          column: 6
        },
        end: {
          line: 82,
          column: 28
        }
      },
      "25": {
        start: {
          line: 83,
          column: 6
        },
        end: {
          line: 83,
          column: 24
        }
      },
      "26": {
        start: {
          line: 88,
          column: 4
        },
        end: {
          line: 88,
          column: 78
        }
      },
      "27": {
        start: {
          line: 88,
          column: 67
        },
        end: {
          line: 88,
          column: 78
        }
      },
      "28": {
        start: {
          line: 89,
          column: 4
        },
        end: {
          line: 89,
          column: 72
        }
      },
      "29": {
        start: {
          line: 89,
          column: 61
        },
        end: {
          line: 89,
          column: 72
        }
      },
      "30": {
        start: {
          line: 90,
          column: 4
        },
        end: {
          line: 90,
          column: 16
        }
      },
      "31": {
        start: {
          line: 94,
          column: 4
        },
        end: {
          line: 96,
          column: 5
        }
      },
      "32": {
        start: {
          line: 95,
          column: 6
        },
        end: {
          line: 95,
          column: 28
        }
      },
      "33": {
        start: {
          line: 97,
          column: 4
        },
        end: {
          line: 99,
          column: 5
        }
      },
      "34": {
        start: {
          line: 98,
          column: 6
        },
        end: {
          line: 98,
          column: 23
        }
      },
      "35": {
        start: {
          line: 100,
          column: 4
        },
        end: {
          line: 102,
          column: 5
        }
      },
      "36": {
        start: {
          line: 101,
          column: 6
        },
        end: {
          line: 101,
          column: 59
        }
      },
      "37": {
        start: {
          line: 106,
          column: 4
        },
        end: {
          line: 106,
          column: 32
        }
      },
      "38": {
        start: {
          line: 107,
          column: 4
        },
        end: {
          line: 107,
          column: 73
        }
      },
      "39": {
        start: {
          line: 108,
          column: 4
        },
        end: {
          line: 108,
          column: 73
        }
      },
      "40": {
        start: {
          line: 109,
          column: 4
        },
        end: {
          line: 109,
          column: 68
        }
      },
      "41": {
        start: {
          line: 111,
          column: 4
        },
        end: {
          line: 111,
          column: 57
        }
      },
      "42": {
        start: {
          line: 112,
          column: 4
        },
        end: {
          line: 112,
          column: 61
        }
      },
      "43": {
        start: {
          line: 114,
          column: 4
        },
        end: {
          line: 114,
          column: 31
        }
      },
      "44": {
        start: {
          line: 114,
          column: 25
        },
        end: {
          line: 114,
          column: 31
        }
      },
      "45": {
        start: {
          line: 115,
          column: 4
        },
        end: {
          line: 121,
          column: 5
        }
      },
      "46": {
        start: {
          line: 116,
          column: 6
        },
        end: {
          line: 118,
          column: 7
        }
      },
      "47": {
        start: {
          line: 117,
          column: 8
        },
        end: {
          line: 117,
          column: 57
        }
      },
      "48": {
        start: {
          line: 119,
          column: 11
        },
        end: {
          line: 121,
          column: 5
        }
      },
      "49": {
        start: {
          line: 120,
          column: 6
        },
        end: {
          line: 120,
          column: 59
        }
      },
      "50": {
        start: {
          line: 125,
          column: 75
        },
        end: {
          line: 125,
          column: 85
        }
      },
      "51": {
        start: {
          line: 126,
          column: 18
        },
        end: {
          line: 126,
          column: 58
        }
      },
      "52": {
        start: {
          line: 127,
          column: 4
        },
        end: {
          line: 143,
          column: 5
        }
      },
      "53": {
        start: {
          line: 129,
          column: 8
        },
        end: {
          line: 129,
          column: 50
        }
      },
      "54": {
        start: {
          line: 129,
          column: 29
        },
        end: {
          line: 129,
          column: 50
        }
      },
      "55": {
        start: {
          line: 130,
          column: 8
        },
        end: {
          line: 130,
          column: 31
        }
      },
      "56": {
        start: {
          line: 131,
          column: 8
        },
        end: {
          line: 131,
          column: 58
        }
      },
      "57": {
        start: {
          line: 131,
          column: 39
        },
        end: {
          line: 131,
          column: 58
        }
      },
      "58": {
        start: {
          line: 132,
          column: 8
        },
        end: {
          line: 132,
          column: 61
        }
      },
      "59": {
        start: {
          line: 132,
          column: 41
        },
        end: {
          line: 132,
          column: 61
        }
      },
      "60": {
        start: {
          line: 134,
          column: 8
        },
        end: {
          line: 140,
          column: 9
        }
      },
      "61": {
        start: {
          line: 135,
          column: 10
        },
        end: {
          line: 135,
          column: 38
        }
      },
      "62": {
        start: {
          line: 136,
          column: 10
        },
        end: {
          line: 136,
          column: 64
        }
      },
      "63": {
        start: {
          line: 138,
          column: 10
        },
        end: {
          line: 138,
          column: 39
        }
      },
      "64": {
        start: {
          line: 139,
          column: 10
        },
        end: {
          line: 139,
          column: 67
        }
      },
      "65": {
        start: {
          line: 147,
          column: 23
        },
        end: {
          line: 147,
          column: 33
        }
      },
      "66": {
        start: {
          line: 148,
          column: 34
        },
        end: {
          line: 148,
          column: 44
        }
      },
      "67": {
        start: {
          line: 149,
          column: 4
        },
        end: {
          line: 149,
          column: 33
        }
      },
      "68": {
        start: {
          line: 149,
          column: 18
        },
        end: {
          line: 149,
          column: 33
        }
      },
      "69": {
        start: {
          line: 151,
          column: 17
        },
        end: {
          line: 151,
          column: 59
        }
      },
      "70": {
        start: {
          line: 152,
          column: 28
        },
        end: {
          line: 152,
          column: 54
        }
      },
      "71": {
        start: {
          line: 153,
          column: 26
        },
        end: {
          line: 153,
          column: 52
        }
      },
      "72": {
        start: {
          line: 154,
          column: 25
        },
        end: {
          line: 154,
          column: 39
        }
      },
      "73": {
        start: {
          line: 155,
          column: 24
        },
        end: {
          line: 155,
          column: 37
        }
      },
      "74": {
        start: {
          line: 156,
          column: 32
        },
        end: {
          line: 156,
          column: 49
        }
      },
      "75": {
        start: {
          line: 157,
          column: 4
        },
        end: {
          line: 161,
          column: 5
        }
      },
      "76": {
        start: {
          line: 158,
          column: 19
        },
        end: {
          line: 158,
          column: 76
        }
      },
      "77": {
        start: {
          line: 159,
          column: 19
        },
        end: {
          line: 159,
          column: 76
        }
      },
      "78": {
        start: {
          line: 160,
          column: 6
        },
        end: {
          line: 160,
          column: 69
        }
      },
      "79": {
        start: {
          line: 163,
          column: 4
        },
        end: {
          line: 181,
          column: 5
        }
      },
      "80": {
        start: {
          line: 164,
          column: 6
        },
        end: {
          line: 165,
          column: 29
        }
      },
      "81": {
        start: {
          line: 164,
          column: 45
        },
        end: {
          line: 164,
          column: 62
        }
      },
      "82": {
        start: {
          line: 165,
          column: 11
        },
        end: {
          line: 165,
          column: 29
        }
      },
      "83": {
        start: {
          line: 167,
          column: 6
        },
        end: {
          line: 171,
          column: 7
        }
      },
      "84": {
        start: {
          line: 168,
          column: 8
        },
        end: {
          line: 168,
          column: 29
        }
      },
      "85": {
        start: {
          line: 169,
          column: 13
        },
        end: {
          line: 171,
          column: 7
        }
      },
      "86": {
        start: {
          line: 170,
          column: 8
        },
        end: {
          line: 170,
          column: 26
        }
      },
      "87": {
        start: {
          line: 173,
          column: 6
        },
        end: {
          line: 174,
          column: 30
        }
      },
      "88": {
        start: {
          line: 173,
          column: 44
        },
        end: {
          line: 173,
          column: 60
        }
      },
      "89": {
        start: {
          line: 174,
          column: 11
        },
        end: {
          line: 174,
          column: 30
        }
      },
      "90": {
        start: {
          line: 176,
          column: 6
        },
        end: {
          line: 180,
          column: 7
        }
      },
      "91": {
        start: {
          line: 177,
          column: 8
        },
        end: {
          line: 177,
          column: 28
        }
      },
      "92": {
        start: {
          line: 178,
          column: 13
        },
        end: {
          line: 180,
          column: 7
        }
      },
      "93": {
        start: {
          line: 179,
          column: 8
        },
        end: {
          line: 179,
          column: 27
        }
      },
      "94": {
        start: {
          line: 182,
          column: 4
        },
        end: {
          line: 182,
          column: 42
        }
      },
      "95": {
        start: {
          line: 186,
          column: 34
        },
        end: {
          line: 186,
          column: 44
        }
      },
      "96": {
        start: {
          line: 188,
          column: 4
        },
        end: {
          line: 188,
          column: 58
        }
      },
      "97": {
        start: {
          line: 188,
          column: 27
        },
        end: {
          line: 188,
          column: 58
        }
      },
      "98": {
        start: {
          line: 189,
          column: 4
        },
        end: {
          line: 193,
          column: 5
        }
      },
      "99": {
        start: {
          line: 190,
          column: 20
        },
        end: {
          line: 190,
          column: 49
        }
      },
      "100": {
        start: {
          line: 191,
          column: 6
        },
        end: {
          line: 191,
          column: 91
        }
      },
      "101": {
        start: {
          line: 192,
          column: 6
        },
        end: {
          line: 192,
          column: 41
        }
      },
      "102": {
        start: {
          line: 194,
          column: 4
        },
        end: {
          line: 194,
          column: 31
        }
      },
      "103": {
        start: {
          line: 198,
          column: 23
        },
        end: {
          line: 198,
          column: 33
        }
      },
      "104": {
        start: {
          line: 199,
          column: 4
        },
        end: {
          line: 203,
          column: 5
        }
      },
      "105": {
        start: {
          line: 200,
          column: 6
        },
        end: {
          line: 200,
          column: 42
        }
      },
      "106": {
        start: {
          line: 201,
          column: 6
        },
        end: {
          line: 201,
          column: 48
        }
      },
      "107": {
        start: {
          line: 202,
          column: 6
        },
        end: {
          line: 202,
          column: 46
        }
      },
      "108": {
        start: {
          line: 207,
          column: 16
        },
        end: {
          line: 207,
          column: 73
        }
      },
      "109": {
        start: {
          line: 209,
          column: 4
        },
        end: {
          line: 211,
          column: 6
        }
      },
      "110": {
        start: {
          line: 210,
          column: 6
        },
        end: {
          line: 210,
          column: 50
        }
      },
      "111": {
        start: {
          line: 215,
          column: 92
        },
        end: {
          line: 215,
          column: 102
        }
      },
      "112": {
        start: {
          line: 216,
          column: 4
        },
        end: {
          line: 232,
          column: 5
        }
      },
      "113": {
        start: {
          line: 217,
          column: 6
        },
        end: {
          line: 217,
          column: 72
        }
      },
      "114": {
        start: {
          line: 218,
          column: 6
        },
        end: {
          line: 218,
          column: 72
        }
      },
      "115": {
        start: {
          line: 219,
          column: 6
        },
        end: {
          line: 219,
          column: 66
        }
      },
      "116": {
        start: {
          line: 220,
          column: 6
        },
        end: {
          line: 220,
          column: 66
        }
      },
      "117": {
        start: {
          line: 221,
          column: 6
        },
        end: {
          line: 221,
          column: 70
        }
      },
      "118": {
        start: {
          line: 222,
          column: 6
        },
        end: {
          line: 224,
          column: 7
        }
      },
      "119": {
        start: {
          line: 223,
          column: 8
        },
        end: {
          line: 223,
          column: 71
        }
      },
      "120": {
        start: {
          line: 226,
          column: 6
        },
        end: {
          line: 226,
          column: 67
        }
      },
      "121": {
        start: {
          line: 227,
          column: 6
        },
        end: {
          line: 227,
          column: 72
        }
      },
      "122": {
        start: {
          line: 228,
          column: 6
        },
        end: {
          line: 228,
          column: 75
        }
      },
      "123": {
        start: {
          line: 229,
          column: 6
        },
        end: {
          line: 229,
          column: 75
        }
      },
      "124": {
        start: {
          line: 230,
          column: 6
        },
        end: {
          line: 230,
          column: 69
        }
      },
      "125": {
        start: {
          line: 231,
          column: 6
        },
        end: {
          line: 231,
          column: 69
        }
      },
      "126": {
        start: {
          line: 236,
          column: 4
        },
        end: {
          line: 236,
          column: 25
        }
      },
      "127": {
        start: {
          line: 240,
          column: 19
        },
        end: {
          line: 240,
          column: 42
        }
      },
      "128": {
        start: {
          line: 241,
          column: 4
        },
        end: {
          line: 241,
          column: 51
        }
      },
      "129": {
        start: {
          line: 241,
          column: 45
        },
        end: {
          line: 241,
          column: 51
        }
      },
      "130": {
        start: {
          line: 242,
          column: 4
        },
        end: {
          line: 242,
          column: 45
        }
      },
      "131": {
        start: {
          line: 242,
          column: 39
        },
        end: {
          line: 242,
          column: 45
        }
      },
      "132": {
        start: {
          line: 243,
          column: 4
        },
        end: {
          line: 243,
          column: 58
        }
      },
      "133": {
        start: {
          line: 243,
          column: 52
        },
        end: {
          line: 243,
          column: 58
        }
      },
      "134": {
        start: {
          line: 244,
          column: 4
        },
        end: {
          line: 244,
          column: 22
        }
      },
      "135": {
        start: {
          line: 248,
          column: 30
        },
        end: {
          line: 248,
          column: 40
        }
      },
      "136": {
        start: {
          line: 249,
          column: 4
        },
        end: {
          line: 249,
          column: 30
        }
      },
      "137": {
        start: {
          line: 249,
          column: 24
        },
        end: {
          line: 249,
          column: 30
        }
      },
      "138": {
        start: {
          line: 250,
          column: 41
        },
        end: {
          line: 250,
          column: 49
        }
      },
      "139": {
        start: {
          line: 251,
          column: 4
        },
        end: {
          line: 251,
          column: 81
        }
      },
      "140": {
        start: {
          line: 251,
          column: 45
        },
        end: {
          line: 251,
          column: 81
        }
      },
      "141": {
        start: {
          line: 252,
          column: 19
        },
        end: {
          line: 252,
          column: 78
        }
      },
      "142": {
        start: {
          line: 253,
          column: 4
        },
        end: {
          line: 253,
          column: 50
        }
      },
      "143": {
        start: {
          line: 257,
          column: 4
        },
        end: {
          line: 257,
          column: 23
        }
      },
      "144": {
        start: {
          line: 261,
          column: 4
        },
        end: {
          line: 261,
          column: 26
        }
      },
      "145": {
        start: {
          line: 262,
          column: 4
        },
        end: {
          line: 262,
          column: 58
        }
      },
      "146": {
        start: {
          line: 262,
          column: 27
        },
        end: {
          line: 262,
          column: 58
        }
      },
      "147": {
        start: {
          line: 263,
          column: 4
        },
        end: {
          line: 263,
          column: 31
        }
      },
      "148": {
        start: {
          line: 263,
          column: 25
        },
        end: {
          line: 263,
          column: 31
        }
      },
      "149": {
        start: {
          line: 264,
          column: 4
        },
        end: {
          line: 264,
          column: 22
        }
      },
      "150": {
        start: {
          line: 268,
          column: 4
        },
        end: {
          line: 268,
          column: 99
        }
      },
      "151": {
        start: {
          line: 268,
          column: 48
        },
        end: {
          line: 268,
          column: 99
        }
      },
      "152": {
        start: {
          line: 268,
          column: 88
        },
        end: {
          line: 268,
          column: 99
        }
      },
      "153": {
        start: {
          line: 269,
          column: 4
        },
        end: {
          line: 269,
          column: 16
        }
      },
      "154": {
        start: {
          line: 273,
          column: 4
        },
        end: {
          line: 273,
          column: 58
        }
      },
      "155": {
        start: {
          line: 273,
          column: 27
        },
        end: {
          line: 273,
          column: 58
        }
      },
      "156": {
        start: {
          line: 277,
          column: 4
        },
        end: {
          line: 277,
          column: 68
        }
      },
      "157": {
        start: {
          line: 277,
          column: 62
        },
        end: {
          line: 277,
          column: 68
        }
      },
      "158": {
        start: {
          line: 278,
          column: 4
        },
        end: {
          line: 278,
          column: 58
        }
      },
      "159": {
        start: {
          line: 278,
          column: 27
        },
        end: {
          line: 278,
          column: 58
        }
      },
      "160": {
        start: {
          line: 279,
          column: 4
        },
        end: {
          line: 279,
          column: 23
        }
      },
      "161": {
        start: {
          line: 283,
          column: 94
        },
        end: {
          line: 283,
          column: 104
        }
      },
      "162": {
        start: {
          line: 284,
          column: 17
        },
        end: {
          line: 284,
          column: 73
        }
      },
      "163": {
        start: {
          line: 285,
          column: 4
        },
        end: {
          line: 287,
          column: 5
        }
      },
      "164": {
        start: {
          line: 286,
          column: 6
        },
        end: {
          line: 286,
          column: 51
        }
      },
      "165": {
        start: {
          line: 289,
          column: 4
        },
        end: {
          line: 289,
          column: 26
        }
      },
      "166": {
        start: {
          line: 290,
          column: 23
        },
        end: {
          line: 290,
          column: 58
        }
      },
      "167": {
        start: {
          line: 291,
          column: 23
        },
        end: {
          line: 291,
          column: 74
        }
      },
      "168": {
        start: {
          line: 292,
          column: 21
        },
        end: {
          line: 292,
          column: 42
        }
      },
      "169": {
        start: {
          line: 294,
          column: 18
        },
        end: {
          line: 294,
          column: 36
        }
      },
      "170": {
        start: {
          line: 295,
          column: 4
        },
        end: {
          line: 304,
          column: 5
        }
      },
      "171": {
        start: {
          line: 297,
          column: 6
        },
        end: {
          line: 297,
          column: 28
        }
      },
      "172": {
        start: {
          line: 298,
          column: 6
        },
        end: {
          line: 298,
          column: 35
        }
      },
      "173": {
        start: {
          line: 299,
          column: 6
        },
        end: {
          line: 299,
          column: 51
        }
      },
      "174": {
        start: {
          line: 299,
          column: 22
        },
        end: {
          line: 299,
          column: 51
        }
      },
      "175": {
        start: {
          line: 300,
          column: 6
        },
        end: {
          line: 300,
          column: 44
        }
      },
      "176": {
        start: {
          line: 300,
          column: 18
        },
        end: {
          line: 300,
          column: 44
        }
      },
      "177": {
        start: {
          line: 301,
          column: 6
        },
        end: {
          line: 301,
          column: 29
        }
      },
      "178": {
        start: {
          line: 303,
          column: 6
        },
        end: {
          line: 303,
          column: 28
        }
      },
      "179": {
        start: {
          line: 305,
          column: 4
        },
        end: {
          line: 305,
          column: 105
        }
      },
      "180": {
        start: {
          line: 306,
          column: 21
        },
        end: {
          line: 306,
          column: 76
        }
      },
      "181": {
        start: {
          line: 307,
          column: 4
        },
        end: {
          line: 308,
          column: 77
        }
      },
      "182": {
        start: {
          line: 308,
          column: 6
        },
        end: {
          line: 308,
          column: 77
        }
      },
      "183": {
        start: {
          line: 309,
          column: 4
        },
        end: {
          line: 321,
          column: 5
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 19,
            column: 20
          },
          end: {
            line: 19,
            column: 21
          }
        },
        loc: {
          start: {
            line: 19,
            column: 72
          },
          end: {
            line: 19,
            column: 91
          }
        },
        line: 19
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 53,
            column: 2
          },
          end: {
            line: 53,
            column: 3
          }
        },
        loc: {
          start: {
            line: 53,
            column: 33
          },
          end: {
            line: 70,
            column: 3
          }
        },
        line: 53
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 72,
            column: 2
          },
          end: {
            line: 72,
            column: 3
          }
        },
        loc: {
          start: {
            line: 72,
            column: 22
          },
          end: {
            line: 85,
            column: 3
          }
        },
        line: 72
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 87,
            column: 2
          },
          end: {
            line: 87,
            column: 3
          }
        },
        loc: {
          start: {
            line: 87,
            column: 70
          },
          end: {
            line: 91,
            column: 3
          }
        },
        line: 87
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 93,
            column: 2
          },
          end: {
            line: 93,
            column: 3
          }
        },
        loc: {
          start: {
            line: 93,
            column: 44
          },
          end: {
            line: 103,
            column: 3
          }
        },
        line: 93
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 105,
            column: 2
          },
          end: {
            line: 105,
            column: 3
          }
        },
        loc: {
          start: {
            line: 105,
            column: 25
          },
          end: {
            line: 122,
            column: 3
          }
        },
        line: 105
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 124,
            column: 2
          },
          end: {
            line: 124,
            column: 3
          }
        },
        loc: {
          start: {
            line: 124,
            column: 25
          },
          end: {
            line: 144,
            column: 3
          }
        },
        line: 124
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 128,
            column: 6
          },
          end: {
            line: 128,
            column: 7
          }
        },
        loc: {
          start: {
            line: 128,
            column: 12
          },
          end: {
            line: 141,
            column: 7
          }
        },
        line: 128
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 146,
            column: 2
          },
          end: {
            line: 146,
            column: 3
          }
        },
        loc: {
          start: {
            line: 146,
            column: 19
          },
          end: {
            line: 183,
            column: 3
          }
        },
        line: 146
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 185,
            column: 2
          },
          end: {
            line: 185,
            column: 3
          }
        },
        loc: {
          start: {
            line: 185,
            column: 17
          },
          end: {
            line: 195,
            column: 3
          }
        },
        line: 185
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 197,
            column: 2
          },
          end: {
            line: 197,
            column: 3
          }
        },
        loc: {
          start: {
            line: 197,
            column: 20
          },
          end: {
            line: 204,
            column: 3
          }
        },
        line: 197
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 206,
            column: 2
          },
          end: {
            line: 206,
            column: 3
          }
        },
        loc: {
          start: {
            line: 206,
            column: 48
          },
          end: {
            line: 212,
            column: 3
          }
        },
        line: 206
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 209,
            column: 29
          },
          end: {
            line: 209,
            column: 30
          }
        },
        loc: {
          start: {
            line: 209,
            column: 57
          },
          end: {
            line: 211,
            column: 5
          }
        },
        line: 209
      },
      "13": {
        name: "(anonymous_13)",
        decl: {
          start: {
            line: 214,
            column: 2
          },
          end: {
            line: 214,
            column: 3
          }
        },
        loc: {
          start: {
            line: 214,
            column: 15
          },
          end: {
            line: 233,
            column: 3
          }
        },
        line: 214
      },
      "14": {
        name: "(anonymous_14)",
        decl: {
          start: {
            line: 235,
            column: 2
          },
          end: {
            line: 235,
            column: 3
          }
        },
        loc: {
          start: {
            line: 235,
            column: 34
          },
          end: {
            line: 237,
            column: 3
          }
        },
        line: 235
      },
      "15": {
        name: "(anonymous_15)",
        decl: {
          start: {
            line: 239,
            column: 2
          },
          end: {
            line: 239,
            column: 3
          }
        },
        loc: {
          start: {
            line: 239,
            column: 27
          },
          end: {
            line: 245,
            column: 3
          }
        },
        line: 239
      },
      "16": {
        name: "(anonymous_16)",
        decl: {
          start: {
            line: 247,
            column: 2
          },
          end: {
            line: 247,
            column: 3
          }
        },
        loc: {
          start: {
            line: 247,
            column: 35
          },
          end: {
            line: 254,
            column: 3
          }
        },
        line: 247
      },
      "17": {
        name: "(anonymous_17)",
        decl: {
          start: {
            line: 256,
            column: 2
          },
          end: {
            line: 256,
            column: 3
          }
        },
        loc: {
          start: {
            line: 256,
            column: 24
          },
          end: {
            line: 258,
            column: 3
          }
        },
        line: 256
      },
      "18": {
        name: "(anonymous_18)",
        decl: {
          start: {
            line: 260,
            column: 2
          },
          end: {
            line: 260,
            column: 3
          }
        },
        loc: {
          start: {
            line: 260,
            column: 15
          },
          end: {
            line: 265,
            column: 3
          }
        },
        line: 260
      },
      "19": {
        name: "(anonymous_19)",
        decl: {
          start: {
            line: 267,
            column: 2
          },
          end: {
            line: 267,
            column: 3
          }
        },
        loc: {
          start: {
            line: 267,
            column: 30
          },
          end: {
            line: 270,
            column: 3
          }
        },
        line: 267
      },
      "20": {
        name: "(anonymous_20)",
        decl: {
          start: {
            line: 272,
            column: 2
          },
          end: {
            line: 272,
            column: 3
          }
        },
        loc: {
          start: {
            line: 272,
            column: 17
          },
          end: {
            line: 274,
            column: 3
          }
        },
        line: 272
      },
      "21": {
        name: "(anonymous_21)",
        decl: {
          start: {
            line: 276,
            column: 2
          },
          end: {
            line: 276,
            column: 3
          }
        },
        loc: {
          start: {
            line: 276,
            column: 33
          },
          end: {
            line: 280,
            column: 3
          }
        },
        line: 276
      },
      "22": {
        name: "(anonymous_22)",
        decl: {
          start: {
            line: 282,
            column: 2
          },
          end: {
            line: 282,
            column: 3
          }
        },
        loc: {
          start: {
            line: 282,
            column: 11
          },
          end: {
            line: 322,
            column: 3
          }
        },
        line: 282
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 56,
            column: 25
          },
          end: {
            line: 56,
            column: 54
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 56,
            column: 25
          },
          end: {
            line: 56,
            column: 45
          }
        }, {
          start: {
            line: 56,
            column: 49
          },
          end: {
            line: 56,
            column: 54
          }
        }],
        line: 56
      },
      "1": {
        loc: {
          start: {
            line: 76,
            column: 4
          },
          end: {
            line: 76,
            column: 37
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 76,
            column: 4
          },
          end: {
            line: 76,
            column: 37
          }
        }, {
          start: {
            line: 76,
            column: 4
          },
          end: {
            line: 76,
            column: 37
          }
        }],
        line: 76
      },
      "2": {
        loc: {
          start: {
            line: 81,
            column: 4
          },
          end: {
            line: 84,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 81,
            column: 4
          },
          end: {
            line: 84,
            column: 5
          }
        }, {
          start: {
            line: 81,
            column: 4
          },
          end: {
            line: 84,
            column: 5
          }
        }],
        line: 81
      },
      "3": {
        loc: {
          start: {
            line: 88,
            column: 4
          },
          end: {
            line: 88,
            column: 78
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 88,
            column: 4
          },
          end: {
            line: 88,
            column: 78
          }
        }, {
          start: {
            line: 88,
            column: 4
          },
          end: {
            line: 88,
            column: 78
          }
        }],
        line: 88
      },
      "4": {
        loc: {
          start: {
            line: 88,
            column: 8
          },
          end: {
            line: 88,
            column: 65
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 88,
            column: 8
          },
          end: {
            line: 88,
            column: 35
          }
        }, {
          start: {
            line: 88,
            column: 39
          },
          end: {
            line: 88,
            column: 65
          }
        }],
        line: 88
      },
      "5": {
        loc: {
          start: {
            line: 89,
            column: 4
          },
          end: {
            line: 89,
            column: 72
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 89,
            column: 4
          },
          end: {
            line: 89,
            column: 72
          }
        }, {
          start: {
            line: 89,
            column: 4
          },
          end: {
            line: 89,
            column: 72
          }
        }],
        line: 89
      },
      "6": {
        loc: {
          start: {
            line: 89,
            column: 8
          },
          end: {
            line: 89,
            column: 59
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 89,
            column: 8
          },
          end: {
            line: 89,
            column: 32
          }
        }, {
          start: {
            line: 89,
            column: 36
          },
          end: {
            line: 89,
            column: 59
          }
        }],
        line: 89
      },
      "7": {
        loc: {
          start: {
            line: 94,
            column: 4
          },
          end: {
            line: 96,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 94,
            column: 4
          },
          end: {
            line: 96,
            column: 5
          }
        }, {
          start: {
            line: 94,
            column: 4
          },
          end: {
            line: 96,
            column: 5
          }
        }],
        line: 94
      },
      "8": {
        loc: {
          start: {
            line: 97,
            column: 4
          },
          end: {
            line: 99,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 97,
            column: 4
          },
          end: {
            line: 99,
            column: 5
          }
        }, {
          start: {
            line: 97,
            column: 4
          },
          end: {
            line: 99,
            column: 5
          }
        }],
        line: 97
      },
      "9": {
        loc: {
          start: {
            line: 100,
            column: 4
          },
          end: {
            line: 102,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 100,
            column: 4
          },
          end: {
            line: 102,
            column: 5
          }
        }, {
          start: {
            line: 100,
            column: 4
          },
          end: {
            line: 102,
            column: 5
          }
        }],
        line: 100
      },
      "10": {
        loc: {
          start: {
            line: 100,
            column: 8
          },
          end: {
            line: 100,
            column: 62
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 100,
            column: 8
          },
          end: {
            line: 100,
            column: 46
          }
        }, {
          start: {
            line: 100,
            column: 50
          },
          end: {
            line: 100,
            column: 62
          }
        }],
        line: 100
      },
      "11": {
        loc: {
          start: {
            line: 114,
            column: 4
          },
          end: {
            line: 114,
            column: 31
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 114,
            column: 4
          },
          end: {
            line: 114,
            column: 31
          }
        }, {
          start: {
            line: 114,
            column: 4
          },
          end: {
            line: 114,
            column: 31
          }
        }],
        line: 114
      },
      "12": {
        loc: {
          start: {
            line: 115,
            column: 4
          },
          end: {
            line: 121,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 115,
            column: 4
          },
          end: {
            line: 121,
            column: 5
          }
        }, {
          start: {
            line: 115,
            column: 4
          },
          end: {
            line: 121,
            column: 5
          }
        }],
        line: 115
      },
      "13": {
        loc: {
          start: {
            line: 116,
            column: 6
          },
          end: {
            line: 118,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 116,
            column: 6
          },
          end: {
            line: 118,
            column: 7
          }
        }, {
          start: {
            line: 116,
            column: 6
          },
          end: {
            line: 118,
            column: 7
          }
        }],
        line: 116
      },
      "14": {
        loc: {
          start: {
            line: 116,
            column: 10
          },
          end: {
            line: 116,
            column: 49
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 116,
            column: 10
          },
          end: {
            line: 116,
            column: 22
          }
        }, {
          start: {
            line: 116,
            column: 26
          },
          end: {
            line: 116,
            column: 49
          }
        }],
        line: 116
      },
      "15": {
        loc: {
          start: {
            line: 119,
            column: 11
          },
          end: {
            line: 121,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 119,
            column: 11
          },
          end: {
            line: 121,
            column: 5
          }
        }, {
          start: {
            line: 119,
            column: 11
          },
          end: {
            line: 121,
            column: 5
          }
        }],
        line: 119
      },
      "16": {
        loc: {
          start: {
            line: 119,
            column: 15
          },
          end: {
            line: 119,
            column: 58
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 119,
            column: 15
          },
          end: {
            line: 119,
            column: 29
          }
        }, {
          start: {
            line: 119,
            column: 33
          },
          end: {
            line: 119,
            column: 58
          }
        }],
        line: 119
      },
      "17": {
        loc: {
          start: {
            line: 126,
            column: 18
          },
          end: {
            line: 126,
            column: 58
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 126,
            column: 25
          },
          end: {
            line: 126,
            column: 40
          }
        }, {
          start: {
            line: 126,
            column: 43
          },
          end: {
            line: 126,
            column: 58
          }
        }],
        line: 126
      },
      "18": {
        loc: {
          start: {
            line: 129,
            column: 8
          },
          end: {
            line: 129,
            column: 50
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 129,
            column: 8
          },
          end: {
            line: 129,
            column: 50
          }
        }, {
          start: {
            line: 129,
            column: 8
          },
          end: {
            line: 129,
            column: 50
          }
        }],
        line: 129
      },
      "19": {
        loc: {
          start: {
            line: 131,
            column: 8
          },
          end: {
            line: 131,
            column: 58
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 131,
            column: 8
          },
          end: {
            line: 131,
            column: 58
          }
        }, {
          start: {
            line: 131,
            column: 8
          },
          end: {
            line: 131,
            column: 58
          }
        }],
        line: 131
      },
      "20": {
        loc: {
          start: {
            line: 131,
            column: 12
          },
          end: {
            line: 131,
            column: 37
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 131,
            column: 12
          },
          end: {
            line: 131,
            column: 16
          }
        }, {
          start: {
            line: 131,
            column: 20
          },
          end: {
            line: 131,
            column: 37
          }
        }],
        line: 131
      },
      "21": {
        loc: {
          start: {
            line: 132,
            column: 8
          },
          end: {
            line: 132,
            column: 61
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 132,
            column: 8
          },
          end: {
            line: 132,
            column: 61
          }
        }, {
          start: {
            line: 132,
            column: 8
          },
          end: {
            line: 132,
            column: 61
          }
        }],
        line: 132
      },
      "22": {
        loc: {
          start: {
            line: 132,
            column: 12
          },
          end: {
            line: 132,
            column: 39
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 132,
            column: 12
          },
          end: {
            line: 132,
            column: 17
          }
        }, {
          start: {
            line: 132,
            column: 21
          },
          end: {
            line: 132,
            column: 39
          }
        }],
        line: 132
      },
      "23": {
        loc: {
          start: {
            line: 134,
            column: 8
          },
          end: {
            line: 140,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 134,
            column: 8
          },
          end: {
            line: 140,
            column: 9
          }
        }, {
          start: {
            line: 134,
            column: 8
          },
          end: {
            line: 140,
            column: 9
          }
        }],
        line: 134
      },
      "24": {
        loc: {
          start: {
            line: 142,
            column: 6
          },
          end: {
            line: 142,
            column: 37
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 142,
            column: 28
          },
          end: {
            line: 142,
            column: 33
          }
        }, {
          start: {
            line: 142,
            column: 36
          },
          end: {
            line: 142,
            column: 37
          }
        }],
        line: 142
      },
      "25": {
        loc: {
          start: {
            line: 149,
            column: 4
          },
          end: {
            line: 149,
            column: 33
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 149,
            column: 4
          },
          end: {
            line: 149,
            column: 33
          }
        }, {
          start: {
            line: 149,
            column: 4
          },
          end: {
            line: 149,
            column: 33
          }
        }],
        line: 149
      },
      "26": {
        loc: {
          start: {
            line: 157,
            column: 4
          },
          end: {
            line: 161,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 157,
            column: 4
          },
          end: {
            line: 161,
            column: 5
          }
        }, {
          start: {
            line: 157,
            column: 4
          },
          end: {
            line: 161,
            column: 5
          }
        }],
        line: 157
      },
      "27": {
        loc: {
          start: {
            line: 160,
            column: 30
          },
          end: {
            line: 160,
            column: 69
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 160,
            column: 44
          },
          end: {
            line: 160,
            column: 56
          }
        }, {
          start: {
            line: 160,
            column: 59
          },
          end: {
            line: 160,
            column: 69
          }
        }],
        line: 160
      },
      "28": {
        loc: {
          start: {
            line: 163,
            column: 4
          },
          end: {
            line: 181,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 163,
            column: 4
          },
          end: {
            line: 181,
            column: 5
          }
        }, {
          start: {
            line: 163,
            column: 4
          },
          end: {
            line: 181,
            column: 5
          }
        }],
        line: 163
      },
      "29": {
        loc: {
          start: {
            line: 164,
            column: 6
          },
          end: {
            line: 165,
            column: 29
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 164,
            column: 6
          },
          end: {
            line: 165,
            column: 29
          }
        }, {
          start: {
            line: 164,
            column: 6
          },
          end: {
            line: 165,
            column: 29
          }
        }],
        line: 164
      },
      "30": {
        loc: {
          start: {
            line: 167,
            column: 6
          },
          end: {
            line: 171,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 167,
            column: 6
          },
          end: {
            line: 171,
            column: 7
          }
        }, {
          start: {
            line: 167,
            column: 6
          },
          end: {
            line: 171,
            column: 7
          }
        }],
        line: 167
      },
      "31": {
        loc: {
          start: {
            line: 169,
            column: 13
          },
          end: {
            line: 171,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 169,
            column: 13
          },
          end: {
            line: 171,
            column: 7
          }
        }, {
          start: {
            line: 169,
            column: 13
          },
          end: {
            line: 171,
            column: 7
          }
        }],
        line: 169
      },
      "32": {
        loc: {
          start: {
            line: 173,
            column: 6
          },
          end: {
            line: 174,
            column: 30
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 173,
            column: 6
          },
          end: {
            line: 174,
            column: 30
          }
        }, {
          start: {
            line: 173,
            column: 6
          },
          end: {
            line: 174,
            column: 30
          }
        }],
        line: 173
      },
      "33": {
        loc: {
          start: {
            line: 176,
            column: 6
          },
          end: {
            line: 180,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 176,
            column: 6
          },
          end: {
            line: 180,
            column: 7
          }
        }, {
          start: {
            line: 176,
            column: 6
          },
          end: {
            line: 180,
            column: 7
          }
        }],
        line: 176
      },
      "34": {
        loc: {
          start: {
            line: 178,
            column: 13
          },
          end: {
            line: 180,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 178,
            column: 13
          },
          end: {
            line: 180,
            column: 7
          }
        }, {
          start: {
            line: 178,
            column: 13
          },
          end: {
            line: 180,
            column: 7
          }
        }],
        line: 178
      },
      "35": {
        loc: {
          start: {
            line: 188,
            column: 4
          },
          end: {
            line: 188,
            column: 58
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 188,
            column: 4
          },
          end: {
            line: 188,
            column: 58
          }
        }, {
          start: {
            line: 188,
            column: 4
          },
          end: {
            line: 188,
            column: 58
          }
        }],
        line: 188
      },
      "36": {
        loc: {
          start: {
            line: 189,
            column: 4
          },
          end: {
            line: 193,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 189,
            column: 4
          },
          end: {
            line: 193,
            column: 5
          }
        }, {
          start: {
            line: 189,
            column: 4
          },
          end: {
            line: 193,
            column: 5
          }
        }],
        line: 189
      },
      "37": {
        loc: {
          start: {
            line: 189,
            column: 8
          },
          end: {
            line: 189,
            column: 44
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 189,
            column: 8
          },
          end: {
            line: 189,
            column: 17
          }
        }, {
          start: {
            line: 189,
            column: 21
          },
          end: {
            line: 189,
            column: 44
          }
        }],
        line: 189
      },
      "38": {
        loc: {
          start: {
            line: 199,
            column: 4
          },
          end: {
            line: 203,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 199,
            column: 4
          },
          end: {
            line: 203,
            column: 5
          }
        }, {
          start: {
            line: 199,
            column: 4
          },
          end: {
            line: 203,
            column: 5
          }
        }],
        line: 199
      },
      "39": {
        loc: {
          start: {
            line: 199,
            column: 8
          },
          end: {
            line: 199,
            column: 56
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 199,
            column: 8
          },
          end: {
            line: 199,
            column: 23
          }
        }, {
          start: {
            line: 199,
            column: 27
          },
          end: {
            line: 199,
            column: 56
          }
        }],
        line: 199
      },
      "40": {
        loc: {
          start: {
            line: 215,
            column: 41
          },
          end: {
            line: 215,
            column: 87
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 215,
            column: 59
          },
          end: {
            line: 215,
            column: 87
          }
        }],
        line: 215
      },
      "41": {
        loc: {
          start: {
            line: 216,
            column: 4
          },
          end: {
            line: 232,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 216,
            column: 4
          },
          end: {
            line: 232,
            column: 5
          }
        }, {
          start: {
            line: 216,
            column: 4
          },
          end: {
            line: 232,
            column: 5
          }
        }],
        line: 216
      },
      "42": {
        loc: {
          start: {
            line: 222,
            column: 6
          },
          end: {
            line: 224,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 222,
            column: 6
          },
          end: {
            line: 224,
            column: 7
          }
        }, {
          start: {
            line: 222,
            column: 6
          },
          end: {
            line: 224,
            column: 7
          }
        }],
        line: 222
      },
      "43": {
        loc: {
          start: {
            line: 222,
            column: 10
          },
          end: {
            line: 222,
            column: 51
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 222,
            column: 10
          },
          end: {
            line: 222,
            column: 28
          }
        }, {
          start: {
            line: 222,
            column: 32
          },
          end: {
            line: 222,
            column: 51
          }
        }],
        line: 222
      },
      "44": {
        loc: {
          start: {
            line: 241,
            column: 4
          },
          end: {
            line: 241,
            column: 51
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 241,
            column: 4
          },
          end: {
            line: 241,
            column: 51
          }
        }, {
          start: {
            line: 241,
            column: 4
          },
          end: {
            line: 241,
            column: 51
          }
        }],
        line: 241
      },
      "45": {
        loc: {
          start: {
            line: 242,
            column: 4
          },
          end: {
            line: 242,
            column: 45
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 242,
            column: 4
          },
          end: {
            line: 242,
            column: 45
          }
        }, {
          start: {
            line: 242,
            column: 4
          },
          end: {
            line: 242,
            column: 45
          }
        }],
        line: 242
      },
      "46": {
        loc: {
          start: {
            line: 243,
            column: 4
          },
          end: {
            line: 243,
            column: 58
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 243,
            column: 4
          },
          end: {
            line: 243,
            column: 58
          }
        }, {
          start: {
            line: 243,
            column: 4
          },
          end: {
            line: 243,
            column: 58
          }
        }],
        line: 243
      },
      "47": {
        loc: {
          start: {
            line: 249,
            column: 4
          },
          end: {
            line: 249,
            column: 30
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 249,
            column: 4
          },
          end: {
            line: 249,
            column: 30
          }
        }, {
          start: {
            line: 249,
            column: 4
          },
          end: {
            line: 249,
            column: 30
          }
        }],
        line: 249
      },
      "48": {
        loc: {
          start: {
            line: 251,
            column: 4
          },
          end: {
            line: 251,
            column: 81
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 251,
            column: 4
          },
          end: {
            line: 251,
            column: 81
          }
        }, {
          start: {
            line: 251,
            column: 4
          },
          end: {
            line: 251,
            column: 81
          }
        }],
        line: 251
      },
      "49": {
        loc: {
          start: {
            line: 251,
            column: 54
          },
          end: {
            line: 251,
            column: 81
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 251,
            column: 54
          },
          end: {
            line: 251,
            column: 69
          }
        }, {
          start: {
            line: 251,
            column: 73
          },
          end: {
            line: 251,
            column: 81
          }
        }],
        line: 251
      },
      "50": {
        loc: {
          start: {
            line: 252,
            column: 19
          },
          end: {
            line: 252,
            column: 78
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 252,
            column: 26
          },
          end: {
            line: 252,
            column: 49
          }
        }, {
          start: {
            line: 252,
            column: 52
          },
          end: {
            line: 252,
            column: 78
          }
        }],
        line: 252
      },
      "51": {
        loc: {
          start: {
            line: 262,
            column: 4
          },
          end: {
            line: 262,
            column: 58
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 262,
            column: 4
          },
          end: {
            line: 262,
            column: 58
          }
        }, {
          start: {
            line: 262,
            column: 4
          },
          end: {
            line: 262,
            column: 58
          }
        }],
        line: 262
      },
      "52": {
        loc: {
          start: {
            line: 263,
            column: 4
          },
          end: {
            line: 263,
            column: 31
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 263,
            column: 4
          },
          end: {
            line: 263,
            column: 31
          }
        }, {
          start: {
            line: 263,
            column: 4
          },
          end: {
            line: 263,
            column: 31
          }
        }],
        line: 263
      },
      "53": {
        loc: {
          start: {
            line: 268,
            column: 48
          },
          end: {
            line: 268,
            column: 99
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 268,
            column: 48
          },
          end: {
            line: 268,
            column: 99
          }
        }, {
          start: {
            line: 268,
            column: 48
          },
          end: {
            line: 268,
            column: 99
          }
        }],
        line: 268
      },
      "54": {
        loc: {
          start: {
            line: 273,
            column: 4
          },
          end: {
            line: 273,
            column: 58
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 273,
            column: 4
          },
          end: {
            line: 273,
            column: 58
          }
        }, {
          start: {
            line: 273,
            column: 4
          },
          end: {
            line: 273,
            column: 58
          }
        }],
        line: 273
      },
      "55": {
        loc: {
          start: {
            line: 277,
            column: 4
          },
          end: {
            line: 277,
            column: 68
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 277,
            column: 4
          },
          end: {
            line: 277,
            column: 68
          }
        }, {
          start: {
            line: 277,
            column: 4
          },
          end: {
            line: 277,
            column: 68
          }
        }],
        line: 277
      },
      "56": {
        loc: {
          start: {
            line: 277,
            column: 8
          },
          end: {
            line: 277,
            column: 60
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 277,
            column: 8
          },
          end: {
            line: 277,
            column: 9
          }
        }, {
          start: {
            line: 277,
            column: 13
          },
          end: {
            line: 277,
            column: 60
          }
        }],
        line: 277
      },
      "57": {
        loc: {
          start: {
            line: 278,
            column: 4
          },
          end: {
            line: 278,
            column: 58
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 278,
            column: 4
          },
          end: {
            line: 278,
            column: 58
          }
        }, {
          start: {
            line: 278,
            column: 4
          },
          end: {
            line: 278,
            column: 58
          }
        }],
        line: 278
      },
      "58": {
        loc: {
          start: {
            line: 284,
            column: 17
          },
          end: {
            line: 284,
            column: 73
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 284,
            column: 48
          },
          end: {
            line: 284,
            column: 55
          }
        }, {
          start: {
            line: 284,
            column: 58
          },
          end: {
            line: 284,
            column: 73
          }
        }],
        line: 284
      },
      "59": {
        loc: {
          start: {
            line: 285,
            column: 4
          },
          end: {
            line: 287,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 285,
            column: 4
          },
          end: {
            line: 287,
            column: 5
          }
        }, {
          start: {
            line: 285,
            column: 4
          },
          end: {
            line: 287,
            column: 5
          }
        }],
        line: 285
      },
      "60": {
        loc: {
          start: {
            line: 285,
            column: 8
          },
          end: {
            line: 285,
            column: 84
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 285,
            column: 10
          },
          end: {
            line: 285,
            column: 26
          }
        }, {
          start: {
            line: 285,
            column: 30
          },
          end: {
            line: 285,
            column: 37
          }
        }, {
          start: {
            line: 285,
            column: 42
          },
          end: {
            line: 285,
            column: 47
          }
        }, {
          start: {
            line: 285,
            column: 52
          },
          end: {
            line: 285,
            column: 71
          }
        }, {
          start: {
            line: 285,
            column: 75
          },
          end: {
            line: 285,
            column: 84
          }
        }],
        line: 285
      },
      "61": {
        loc: {
          start: {
            line: 295,
            column: 4
          },
          end: {
            line: 304,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 295,
            column: 4
          },
          end: {
            line: 304,
            column: 5
          }
        }, {
          start: {
            line: 295,
            column: 4
          },
          end: {
            line: 304,
            column: 5
          }
        }],
        line: 295
      },
      "62": {
        loc: {
          start: {
            line: 299,
            column: 6
          },
          end: {
            line: 299,
            column: 51
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 299,
            column: 6
          },
          end: {
            line: 299,
            column: 51
          }
        }, {
          start: {
            line: 299,
            column: 6
          },
          end: {
            line: 299,
            column: 51
          }
        }],
        line: 299
      },
      "63": {
        loc: {
          start: {
            line: 300,
            column: 6
          },
          end: {
            line: 300,
            column: 44
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 300,
            column: 6
          },
          end: {
            line: 300,
            column: 44
          }
        }, {
          start: {
            line: 300,
            column: 6
          },
          end: {
            line: 300,
            column: 44
          }
        }],
        line: 300
      },
      "64": {
        loc: {
          start: {
            line: 306,
            column: 21
          },
          end: {
            line: 306,
            column: 76
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 306,
            column: 40
          },
          end: {
            line: 306,
            column: 65
          }
        }, {
          start: {
            line: 306,
            column: 68
          },
          end: {
            line: 306,
            column: 76
          }
        }],
        line: 306
      },
      "65": {
        loc: {
          start: {
            line: 307,
            column: 4
          },
          end: {
            line: 308,
            column: 77
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 307,
            column: 4
          },
          end: {
            line: 308,
            column: 77
          }
        }, {
          start: {
            line: 307,
            column: 4
          },
          end: {
            line: 308,
            column: 77
          }
        }],
        line: 307
      },
      "66": {
        loc: {
          start: {
            line: 307,
            column: 8
          },
          end: {
            line: 307,
            column: 54
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 307,
            column: 8
          },
          end: {
            line: 307,
            column: 38
          }
        }, {
          start: {
            line: 307,
            column: 42
          },
          end: {
            line: 307,
            column: 54
          }
        }],
        line: 307
      },
      "67": {
        loc: {
          start: {
            line: 311,
            column: 8
          },
          end: {
            line: 311,
            column: 93
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 311,
            column: 8
          },
          end: {
            line: 311,
            column: 17
          }
        }, {
          start: {
            line: 311,
            column: 21
          },
          end: {
            line: 311,
            column: 93
          }
        }],
        line: 311
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0,
      "57": 0,
      "58": 0,
      "59": 0,
      "60": 0,
      "61": 0,
      "62": 0,
      "63": 0,
      "64": 0,
      "65": 0,
      "66": 0,
      "67": 0,
      "68": 0,
      "69": 0,
      "70": 0,
      "71": 0,
      "72": 0,
      "73": 0,
      "74": 0,
      "75": 0,
      "76": 0,
      "77": 0,
      "78": 0,
      "79": 0,
      "80": 0,
      "81": 0,
      "82": 0,
      "83": 0,
      "84": 0,
      "85": 0,
      "86": 0,
      "87": 0,
      "88": 0,
      "89": 0,
      "90": 0,
      "91": 0,
      "92": 0,
      "93": 0,
      "94": 0,
      "95": 0,
      "96": 0,
      "97": 0,
      "98": 0,
      "99": 0,
      "100": 0,
      "101": 0,
      "102": 0,
      "103": 0,
      "104": 0,
      "105": 0,
      "106": 0,
      "107": 0,
      "108": 0,
      "109": 0,
      "110": 0,
      "111": 0,
      "112": 0,
      "113": 0,
      "114": 0,
      "115": 0,
      "116": 0,
      "117": 0,
      "118": 0,
      "119": 0,
      "120": 0,
      "121": 0,
      "122": 0,
      "123": 0,
      "124": 0,
      "125": 0,
      "126": 0,
      "127": 0,
      "128": 0,
      "129": 0,
      "130": 0,
      "131": 0,
      "132": 0,
      "133": 0,
      "134": 0,
      "135": 0,
      "136": 0,
      "137": 0,
      "138": 0,
      "139": 0,
      "140": 0,
      "141": 0,
      "142": 0,
      "143": 0,
      "144": 0,
      "145": 0,
      "146": 0,
      "147": 0,
      "148": 0,
      "149": 0,
      "150": 0,
      "151": 0,
      "152": 0,
      "153": 0,
      "154": 0,
      "155": 0,
      "156": 0,
      "157": 0,
      "158": 0,
      "159": 0,
      "160": 0,
      "161": 0,
      "162": 0,
      "163": 0,
      "164": 0,
      "165": 0,
      "166": 0,
      "167": 0,
      "168": 0,
      "169": 0,
      "170": 0,
      "171": 0,
      "172": 0,
      "173": 0,
      "174": 0,
      "175": 0,
      "176": 0,
      "177": 0,
      "178": 0,
      "179": 0,
      "180": 0,
      "181": 0,
      "182": 0,
      "183": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0],
      "16": [0, 0],
      "17": [0, 0],
      "18": [0, 0],
      "19": [0, 0],
      "20": [0, 0],
      "21": [0, 0],
      "22": [0, 0],
      "23": [0, 0],
      "24": [0, 0],
      "25": [0, 0],
      "26": [0, 0],
      "27": [0, 0],
      "28": [0, 0],
      "29": [0, 0],
      "30": [0, 0],
      "31": [0, 0],
      "32": [0, 0],
      "33": [0, 0],
      "34": [0, 0],
      "35": [0, 0],
      "36": [0, 0],
      "37": [0, 0],
      "38": [0, 0],
      "39": [0, 0],
      "40": [0],
      "41": [0, 0],
      "42": [0, 0],
      "43": [0, 0],
      "44": [0, 0],
      "45": [0, 0],
      "46": [0, 0],
      "47": [0, 0],
      "48": [0, 0],
      "49": [0, 0],
      "50": [0, 0],
      "51": [0, 0],
      "52": [0, 0],
      "53": [0, 0],
      "54": [0, 0],
      "55": [0, 0],
      "56": [0, 0],
      "57": [0, 0],
      "58": [0, 0],
      "59": [0, 0],
      "60": [0, 0, 0, 0, 0],
      "61": [0, 0],
      "62": [0, 0],
      "63": [0, 0],
      "64": [0, 0],
      "65": [0, 0],
      "66": [0, 0],
      "67": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _classCallCheck from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _get from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _jsxFileName = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Popover/Panel.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React from 'react';
import ReactDOM from 'react-dom';
import classnames from 'classnames';
import { Component } from '../component';
import { getPosition } from '../utils/dom/popover';
import { isFunc } from '../utils/is';
import { getParent } from '../utils/dom/element';
import { popoverClass } from './styles';
import { docSize } from '../utils/dom/document';
import isDOMElement from '../utils/dom/isDOMElement';
import { Provider as AbsoluteProvider } from '../Table/context';
import { consumer, Provider } from './context';
import { getUidStr } from '../utils/uid';
import { isInDocument } from '../utils/dom/isInDocument';
import getCommonContainer from '../utils/dom/popContainer';
import { Provider as ScrollProvider } from '../Scroll/context';
cov_183vvehy76.s[0]++;

var emptyEvent = function emptyEvent(e) {
  cov_183vvehy76.f[0]++;
  cov_183vvehy76.s[1]++;
  return e.stopPropagation();
};

var DefaultProps = (cov_183vvehy76.s[2]++, {
  background: '',
  trigger: 'hover',
  mouseEnterDelay: 0,
  mouseLeaveDelay: 0,
  priorityDirection: 'vertical',
  showArrow: true
});

var Panel =
/*#__PURE__*/
function (_Component) {
  _inherits(Panel, _Component);

  var _super = _createSuper2(Panel);

  function Panel(props) {
    var _this;

    _classCallCheck(this, Panel);

    cov_183vvehy76.f[1]++;
    cov_183vvehy76.s[3]++;
    _this = _super.call(this, props);
    _this.isRendered = void 0;
    _this.chain = void 0;
    _this.id = void 0;
    _this.element = void 0;
    _this.parentElement = void 0;
    _this.placeholder = void 0;
    _this.container = void 0;
    _this.delayTimeout = void 0;
    cov_183vvehy76.s[4]++;
    _this.state = {
      show: (cov_183vvehy76.b[0][0]++, props.defaultVisible) || (cov_183vvehy76.b[0][1]++, false)
    };
    cov_183vvehy76.s[5]++;
    _this.isRendered = false;
    cov_183vvehy76.s[6]++;
    _this.chain = [];
    cov_183vvehy76.s[7]++;
    _this.id = "popover_".concat(getUidStr());
    cov_183vvehy76.s[8]++;
    _this.placeholderRef = _this.placeholderRef.bind(_assertThisInitialized(_this));
    cov_183vvehy76.s[9]++;
    _this.clickAway = _this.clickAway.bind(_assertThisInitialized(_this));
    cov_183vvehy76.s[10]++;
    _this.handleShow = _this.handleShow.bind(_assertThisInitialized(_this));
    cov_183vvehy76.s[11]++;
    _this.handleHide = _this.handleHide.bind(_assertThisInitialized(_this));
    cov_183vvehy76.s[12]++;
    _this.setShow = _this.setShow.bind(_assertThisInitialized(_this));
    cov_183vvehy76.s[13]++;
    _this.bindChain = _this.bindChain.bind(_assertThisInitialized(_this));
    cov_183vvehy76.s[14]++;
    _this.handleCancel = _this.handleCancel.bind(_assertThisInitialized(_this));
    cov_183vvehy76.s[15]++;
    _this.createContainer = _this.createContainer.bind(_assertThisInitialized(_this));
    cov_183vvehy76.s[16]++;
    _this.element = document.createElement('div');
    return _this;
  }

  _createClass(Panel, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      cov_183vvehy76.f[2]++;
      cov_183vvehy76.s[17]++;

      _get(_getPrototypeOf(Panel.prototype), "componentDidMount", this).call(this);

      var _ref = (cov_183vvehy76.s[18]++, this.props),
          bindChain = _ref.bindChain;

      cov_183vvehy76.s[19]++;

      if (bindChain) {
        cov_183vvehy76.b[1][0]++;
        cov_183vvehy76.s[20]++;
        bindChain(this.id);
      } else {
        cov_183vvehy76.b[1][1]++;
      }

      cov_183vvehy76.s[21]++;
      this.parentElement = this.placeholder.parentElement;
      cov_183vvehy76.s[22]++;
      this.bindEvents();
      cov_183vvehy76.s[23]++;

      if (this.props.visible) {
        cov_183vvehy76.b[2][0]++;
        cov_183vvehy76.s[24]++;
        this.createContainer();
        cov_183vvehy76.s[25]++;
        this.forceUpdate();
      } else {
        cov_183vvehy76.b[2][1]++;
      }
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      cov_183vvehy76.f[3]++;
      cov_183vvehy76.s[26]++;

      if ((cov_183vvehy76.b[4][0]++, this.props.visible === true) || (cov_183vvehy76.b[4][1]++, nextProps.visible === true)) {
        cov_183vvehy76.b[3][0]++;
        cov_183vvehy76.s[27]++;
        return true;
      } else {
        cov_183vvehy76.b[3][1]++;
      }

      cov_183vvehy76.s[28]++;

      if ((cov_183vvehy76.b[6][0]++, this.state.show === true) || (cov_183vvehy76.b[6][1]++, nextState.show === true)) {
        cov_183vvehy76.b[5][0]++;
        cov_183vvehy76.s[29]++;
        return true;
      } else {
        cov_183vvehy76.b[5][1]++;
      }

      cov_183vvehy76.s[30]++;
      return false;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      cov_183vvehy76.f[4]++;
      cov_183vvehy76.s[31]++;

      if (this.props.visible) {
        cov_183vvehy76.b[7][0]++;
        cov_183vvehy76.s[32]++;
        this.createContainer();
      } else {
        cov_183vvehy76.b[7][1]++;
      }

      cov_183vvehy76.s[33]++;

      if (this.props.trigger !== prevProps.trigger) {
        cov_183vvehy76.b[8][0]++;
        cov_183vvehy76.s[34]++;
        this.bindEvents();
      } else {
        cov_183vvehy76.b[8][1]++;
      }

      cov_183vvehy76.s[35]++;

      if ((cov_183vvehy76.b[10][0]++, this.props.zIndex !== prevProps.zIndex) && (cov_183vvehy76.b[10][1]++, this.element)) {
        cov_183vvehy76.b[9][0]++;
        cov_183vvehy76.s[36]++;
        this.element.style.zIndex = String(this.props.zIndex);
      } else {
        cov_183vvehy76.b[9][1]++;
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      cov_183vvehy76.f[5]++;
      cov_183vvehy76.s[37]++;

      _get(_getPrototypeOf(Panel.prototype), "componentWillUnmount", this).call(this);

      cov_183vvehy76.s[38]++;
      this.parentElement.removeEventListener('mouseenter', this.handleShow);
      cov_183vvehy76.s[39]++;
      this.parentElement.removeEventListener('mouseleave', this.handleHide);
      cov_183vvehy76.s[40]++;
      this.parentElement.removeEventListener('click', this.handleShow);
      cov_183vvehy76.s[41]++;
      document.removeEventListener('click', this.clickAway);
      cov_183vvehy76.s[42]++;
      document.removeEventListener('mousedown', this.clickAway);
      cov_183vvehy76.s[43]++;

      if (!this.container) {
        cov_183vvehy76.b[11][0]++;
        cov_183vvehy76.s[44]++;
        return;
      } else {
        cov_183vvehy76.b[11][1]++;
      }

      cov_183vvehy76.s[45]++;

      if (this.container === getCommonContainer()) {
        cov_183vvehy76.b[12][0]++;
        cov_183vvehy76.s[46]++;

        if ((cov_183vvehy76.b[14][0]++, this.element) && (cov_183vvehy76.b[14][1]++, this.element.parentNode)) {
          cov_183vvehy76.b[13][0]++;
          cov_183vvehy76.s[47]++;
          this.element.parentNode.removeChild(this.element);
        } else {
          cov_183vvehy76.b[13][1]++;
        }
      } else {
        cov_183vvehy76.b[12][1]++;
        cov_183vvehy76.s[48]++;

        if ((cov_183vvehy76.b[16][0]++, this.container) && (cov_183vvehy76.b[16][1]++, this.container.parentNode)) {
          cov_183vvehy76.b[15][0]++;
          cov_183vvehy76.s[49]++;
          this.container.parentNode.removeChild(this.container);
        } else {
          cov_183vvehy76.b[15][1]++;
        }
      }
    }
  }, {
    key: "setShow",
    value: function setShow(show) {
      var _this2 = this;

      cov_183vvehy76.f[6]++;

      var _ref2 = (cov_183vvehy76.s[50]++, this.props),
          onVisibleChange = _ref2.onVisibleChange,
          mouseEnterDelay = _ref2.mouseEnterDelay,
          mouseLeaveDelay = _ref2.mouseLeaveDelay,
          trigger = _ref2.trigger;

      var delay = (cov_183vvehy76.s[51]++, show ? (cov_183vvehy76.b[17][0]++, mouseEnterDelay) : (cov_183vvehy76.b[17][1]++, mouseLeaveDelay));
      cov_183vvehy76.s[52]++;
      this.delayTimeout = setTimeout(function () {
        cov_183vvehy76.f[7]++;
        cov_183vvehy76.s[53]++;

        if (onVisibleChange) {
          cov_183vvehy76.b[18][0]++;
          cov_183vvehy76.s[54]++;
          onVisibleChange(show);
        } else {
          cov_183vvehy76.b[18][1]++;
        }

        cov_183vvehy76.s[55]++;

        _this2.setState({
          show: show
        });

        cov_183vvehy76.s[56]++;

        if ((cov_183vvehy76.b[20][0]++, show) && (cov_183vvehy76.b[20][1]++, _this2.props.onOpen)) {
          cov_183vvehy76.b[19][0]++;
          cov_183vvehy76.s[57]++;

          _this2.props.onOpen();
        } else {
          cov_183vvehy76.b[19][1]++;
        }

        cov_183vvehy76.s[58]++;

        if ((cov_183vvehy76.b[22][0]++, !show) && (cov_183vvehy76.b[22][1]++, _this2.props.onClose)) {
          cov_183vvehy76.b[21][0]++;
          cov_183vvehy76.s[59]++;

          _this2.props.onClose();
        } else {
          cov_183vvehy76.b[21][1]++;
        }

        cov_183vvehy76.s[60]++;

        if (show) {
          cov_183vvehy76.b[23][0]++;
          cov_183vvehy76.s[61]++;

          _this2.bindScrollDismiss(true);

          cov_183vvehy76.s[62]++;
          document.addEventListener('mousedown', _this2.clickAway);
        } else {
          cov_183vvehy76.b[23][1]++;
          cov_183vvehy76.s[63]++;

          _this2.bindScrollDismiss(false);

          cov_183vvehy76.s[64]++;
          document.removeEventListener('mousedown', _this2.clickAway);
        }
      }, trigger === 'hover' ? (cov_183vvehy76.b[24][0]++, delay) : (cov_183vvehy76.b[24][1]++, 0));
    }
  }, {
    key: "getPositionStr",
    value: function getPositionStr() {
      cov_183vvehy76.f[8]++;

      var _ref3 = (cov_183vvehy76.s[65]++, this.props),
          position = _ref3.position;

      var _ref4 = (cov_183vvehy76.s[66]++, this.props),
          priorityDirection = _ref4.priorityDirection;

      cov_183vvehy76.s[67]++;

      if (position) {
        cov_183vvehy76.b[25][0]++;
        cov_183vvehy76.s[68]++;
        return position;
      } else {
        cov_183vvehy76.b[25][1]++;
      }

      var rect = (cov_183vvehy76.s[69]++, this.parentElement.getBoundingClientRect());
      var horizontalPoint = (cov_183vvehy76.s[70]++, rect.left + rect.width / 2);
      var verticalPoint = (cov_183vvehy76.s[71]++, rect.top + rect.height / 2);
      var windowHeight = (cov_183vvehy76.s[72]++, docSize.height);
      var windowWidth = (cov_183vvehy76.s[73]++, docSize.width);
      var tempPriorityDirection = (cov_183vvehy76.s[74]++, priorityDirection);
      cov_183vvehy76.s[75]++;

      if (priorityDirection === 'auto') {
        cov_183vvehy76.b[26][0]++;
        var maxX = (cov_183vvehy76.s[76]++, Math.max(rect.left, windowWidth - rect.left - rect.width));
        var maxY = (cov_183vvehy76.s[77]++, Math.max(rect.top, windowHeight - rect.top - rect.height));
        cov_183vvehy76.s[78]++;
        tempPriorityDirection = maxX > maxY ? (cov_183vvehy76.b[27][0]++, 'horizontal') : (cov_183vvehy76.b[27][1]++, 'vertical');
      } else {
        cov_183vvehy76.b[26][1]++;
      }

      cov_183vvehy76.s[79]++;

      if (tempPriorityDirection === 'horizontal') {
        cov_183vvehy76.b[28][0]++;
        cov_183vvehy76.s[80]++;

        if (horizontalPoint > windowWidth / 2) {
          cov_183vvehy76.b[29][0]++;
          cov_183vvehy76.s[81]++;
          position = 'left';
        } else {
          cov_183vvehy76.b[29][1]++;
          cov_183vvehy76.s[82]++;
          position = 'right';
        }

        cov_183vvehy76.s[83]++;

        if (verticalPoint > windowHeight * 0.6) {
          cov_183vvehy76.b[30][0]++;
          cov_183vvehy76.s[84]++;
          position += '-bottom';
        } else {
          cov_183vvehy76.b[30][1]++;
          cov_183vvehy76.s[85]++;

          if (verticalPoint < windowHeight * 0.4) {
            cov_183vvehy76.b[31][0]++;
            cov_183vvehy76.s[86]++;
            position += '-top';
          } else {
            cov_183vvehy76.b[31][1]++;
          }
        }
      } else {
        cov_183vvehy76.b[28][1]++;
        cov_183vvehy76.s[87]++;

        if (verticalPoint > windowHeight / 2) {
          cov_183vvehy76.b[32][0]++;
          cov_183vvehy76.s[88]++;
          position = 'top';
        } else {
          cov_183vvehy76.b[32][1]++;
          cov_183vvehy76.s[89]++;
          position = 'bottom';
        }

        cov_183vvehy76.s[90]++;

        if (horizontalPoint > windowWidth * 0.6) {
          cov_183vvehy76.b[33][0]++;
          cov_183vvehy76.s[91]++;
          position += '-right';
        } else {
          cov_183vvehy76.b[33][1]++;
          cov_183vvehy76.s[92]++;

          if (horizontalPoint < windowWidth * 0.4) {
            cov_183vvehy76.b[34][0]++;
            cov_183vvehy76.s[93]++;
            position += '-left';
          } else {
            cov_183vvehy76.b[34][1]++;
          }
        }
      }

      cov_183vvehy76.s[94]++;
      return position;
    }
  }, {
    key: "getContainer",
    value: function getContainer() {
      cov_183vvehy76.f[9]++;

      var _ref5 = (cov_183vvehy76.s[95]++, this.props),
          getPopupContainer = _ref5.getPopupContainer;

      var container;
      cov_183vvehy76.s[96]++;

      if (getPopupContainer) {
        cov_183vvehy76.b[35][0]++;
        cov_183vvehy76.s[97]++;
        container = getPopupContainer();
      } else {
        cov_183vvehy76.b[35][1]++;
      }

      cov_183vvehy76.s[98]++;

      if ((cov_183vvehy76.b[37][0]++, container) && (cov_183vvehy76.b[37][1]++, isDOMElement(container))) {
        cov_183vvehy76.b[36][0]++;
        var child = (cov_183vvehy76.s[99]++, document.createElement('div'));
        cov_183vvehy76.s[100]++;
        child.setAttribute('style', ' position: absolute; top: 0px; left: 0px; width: 100% ');
        cov_183vvehy76.s[101]++;
        return container.appendChild(child);
      } else {
        cov_183vvehy76.b[36][1]++;
      }

      cov_183vvehy76.s[102]++;
      return getCommonContainer();
    }
  }, {
    key: "createContainer",
    value: function createContainer() {
      cov_183vvehy76.f[10]++;

      var _ref6 = (cov_183vvehy76.s[103]++, this.props),
          zIndex = _ref6.zIndex;

      cov_183vvehy76.s[104]++;

      if ((cov_183vvehy76.b[39][0]++, !this.container) || (cov_183vvehy76.b[39][1]++, !isInDocument(this.container))) {
        cov_183vvehy76.b[38][0]++;
        cov_183vvehy76.s[105]++;
        this.container = this.getContainer();
        cov_183vvehy76.s[106]++;
        this.element.style.zIndex = String(zIndex);
        cov_183vvehy76.s[107]++;
        this.container.appendChild(this.element);
      } else {
        cov_183vvehy76.b[38][1]++;
      }
    }
  }, {
    key: "updatePosition",
    value: function updatePosition(position) {
      var _this3 = this;

      cov_183vvehy76.f[11]++;
      var pos = (cov_183vvehy76.s[108]++, getPosition(position, this.parentElement, this.container)); // eslint-disable-next-line

      cov_183vvehy76.s[109]++;
      Object.keys(pos).forEach(function (attr) {
        cov_183vvehy76.f[12]++;
        cov_183vvehy76.s[110]++;
        _this3.element.style[attr] = String(pos[attr]);
      });
    }
  }, {
    key: "bindEvents",
    value: function bindEvents() {
      cov_183vvehy76.f[13]++;

      var _ref7 = (cov_183vvehy76.s[111]++, this.props),
          trigger = _ref7.trigger,
          clickToCancelDelay = _ref7.clickToCancelDelay,
          _ref7$mouseEnterDelay = _ref7.mouseEnterDelay,
          mouseEnterDelay = _ref7$mouseEnterDelay === void 0 ? (cov_183vvehy76.b[40][0]++, DefaultProps.mouseEnterDelay) : _ref7$mouseEnterDelay;

      cov_183vvehy76.s[112]++;

      if (trigger === 'hover') {
        cov_183vvehy76.b[41][0]++;
        cov_183vvehy76.s[113]++;
        this.parentElement.addEventListener('mouseenter', this.handleShow);
        cov_183vvehy76.s[114]++;
        this.parentElement.addEventListener('mouseleave', this.handleHide);
        cov_183vvehy76.s[115]++;
        this.element.addEventListener('mouseenter', this.handleShow);
        cov_183vvehy76.s[116]++;
        this.element.addEventListener('mouseleave', this.handleHide);
        cov_183vvehy76.s[117]++;
        this.parentElement.removeEventListener('click', this.handleShow);
        cov_183vvehy76.s[118]++;

        if ((cov_183vvehy76.b[43][0]++, clickToCancelDelay) && (cov_183vvehy76.b[43][1]++, mouseEnterDelay > 0)) {
          cov_183vvehy76.b[42][0]++;
          cov_183vvehy76.s[119]++;
          this.parentElement.addEventListener('click', this.handleCancel);
        } else {
          cov_183vvehy76.b[42][1]++;
        }
      } else {
        cov_183vvehy76.b[41][1]++;
        cov_183vvehy76.s[120]++;
        this.parentElement.addEventListener('click', this.handleShow);
        cov_183vvehy76.s[121]++;
        this.parentElement.removeEventListener('click', this.handleCancel);
        cov_183vvehy76.s[122]++;
        this.parentElement.removeEventListener('mouseenter', this.handleShow);
        cov_183vvehy76.s[123]++;
        this.parentElement.removeEventListener('mouseleave', this.handleHide);
        cov_183vvehy76.s[124]++;
        this.element.removeEventListener('mouseenter', this.handleShow);
        cov_183vvehy76.s[125]++;
        this.element.removeEventListener('mouseleave', this.handleHide);
      }
    }
  }, {
    key: "placeholderRef",
    value: function placeholderRef(el) {
      cov_183vvehy76.f[14]++;
      cov_183vvehy76.s[126]++;
      this.placeholder = el;
    }
  }, {
    key: "clickAway",
    value: function clickAway(e) {
      cov_183vvehy76.f[15]++;
      var target = (cov_183vvehy76.s[127]++, e.target);
      cov_183vvehy76.s[128]++;

      if (this.parentElement.contains(target)) {
        cov_183vvehy76.b[44][0]++;
        cov_183vvehy76.s[129]++;
        return;
      } else {
        cov_183vvehy76.b[44][1]++;
      }

      cov_183vvehy76.s[130]++;

      if (this.element.contains(target)) {
        cov_183vvehy76.b[45][0]++;
        cov_183vvehy76.s[131]++;
        return;
      } else {
        cov_183vvehy76.b[45][1]++;
      }

      cov_183vvehy76.s[132]++;

      if (getParent(target, ".".concat(popoverClass('_')))) {
        cov_183vvehy76.b[46][0]++;
        cov_183vvehy76.s[133]++;
        return;
      } else {
        cov_183vvehy76.b[46][1]++;
      }

      cov_183vvehy76.s[134]++;
      this.handleHide(0);
    }
  }, {
    key: "bindScrollDismiss",
    value: function bindScrollDismiss(show) {
      cov_183vvehy76.f[16]++;

      var _ref8 = (cov_183vvehy76.s[135]++, this.props),
          scrollDismiss = _ref8.scrollDismiss;

      cov_183vvehy76.s[136]++;

      if (!scrollDismiss) {
        cov_183vvehy76.b[47][0]++;
        cov_183vvehy76.s[137]++;
        return;
      } else {
        cov_183vvehy76.b[47][1]++;
      }

      var target = (cov_183vvehy76.s[138]++, document);
      cov_183vvehy76.s[139]++;

      if (typeof scrollDismiss === 'function') {
        cov_183vvehy76.b[48][0]++;
        cov_183vvehy76.s[140]++;
        target = (cov_183vvehy76.b[49][0]++, scrollDismiss()) || (cov_183vvehy76.b[49][1]++, document);
      } else {
        cov_183vvehy76.b[48][1]++;
      }

      var method = (cov_183vvehy76.s[141]++, show ? (cov_183vvehy76.b[50][0]++, target.addEventListener) : (cov_183vvehy76.b[50][1]++, target.removeEventListener));
      cov_183vvehy76.s[142]++;
      method.call(target, 'scroll', this.handleHide);
    }
  }, {
    key: "bindChain",
    value: function bindChain(id) {
      cov_183vvehy76.f[17]++;
      cov_183vvehy76.s[143]++;
      this.chain.push(id);
    }
  }, {
    key: "handleShow",
    value: function handleShow() {
      cov_183vvehy76.f[18]++;
      cov_183vvehy76.s[144]++;
      this.createContainer();
      cov_183vvehy76.s[145]++;

      if (this.delayTimeout) {
        cov_183vvehy76.b[51][0]++;
        cov_183vvehy76.s[146]++;
        clearTimeout(this.delayTimeout);
      } else {
        cov_183vvehy76.b[51][1]++;
      }

      cov_183vvehy76.s[147]++;

      if (this.state.show) {
        cov_183vvehy76.b[52][0]++;
        cov_183vvehy76.s[148]++;
        return;
      } else {
        cov_183vvehy76.b[52][1]++;
      }

      cov_183vvehy76.s[149]++;
      this.setShow(true);
    }
  }, {
    key: "isChildren",
    value: function isChildren(el) {
      cov_183vvehy76.f[19]++;
      cov_183vvehy76.s[150]++;

      for (var i = 0; i < this.chain.length; i++) {
        cov_183vvehy76.s[151]++;

        if (getParent(el, ".".concat(this.chain[i]))) {
          cov_183vvehy76.b[53][0]++;
          cov_183vvehy76.s[152]++;
          return true;
        } else {
          cov_183vvehy76.b[53][1]++;
        }
      }

      cov_183vvehy76.s[153]++;
      return false;
    }
  }, {
    key: "handleCancel",
    value: function handleCancel() {
      cov_183vvehy76.f[20]++;
      cov_183vvehy76.s[154]++;

      if (this.delayTimeout) {
        cov_183vvehy76.b[54][0]++;
        cov_183vvehy76.s[155]++;
        clearTimeout(this.delayTimeout);
      } else {
        cov_183vvehy76.b[54][1]++;
      }
    }
  }, {
    key: "handleHide",
    value: function handleHide(e) {
      cov_183vvehy76.f[21]++;
      cov_183vvehy76.s[156]++;

      if ((cov_183vvehy76.b[56][0]++, e) && (cov_183vvehy76.b[56][1]++, this.isChildren(e.relatedTarget))) {
        cov_183vvehy76.b[55][0]++;
        cov_183vvehy76.s[157]++;
        return;
      } else {
        cov_183vvehy76.b[55][1]++;
      }

      cov_183vvehy76.s[158]++;

      if (this.delayTimeout) {
        cov_183vvehy76.b[57][0]++;
        cov_183vvehy76.s[159]++;
        clearTimeout(this.delayTimeout);
      } else {
        cov_183vvehy76.b[57][1]++;
      }

      cov_183vvehy76.s[160]++;
      this.setShow(false);
    }
  }, {
    key: "render",
    value: function render() {
      cov_183vvehy76.f[22]++;

      var _ref9 = (cov_183vvehy76.s[161]++, this.props),
          background = _ref9.background,
          border = _ref9.border,
          children = _ref9.children,
          type = _ref9.type,
          visible = _ref9.visible,
          showArrow = _ref9.showArrow,
          useTextStyle = _ref9.useTextStyle,
          destroy = _ref9.destroy;

      var show = (cov_183vvehy76.s[162]++, typeof visible === 'boolean' ? (cov_183vvehy76.b[58][0]++, visible) : (cov_183vvehy76.b[58][1]++, this.state.show));
      cov_183vvehy76.s[163]++;

      if (((cov_183vvehy76.b[60][0]++, !this.isRendered) || (cov_183vvehy76.b[60][1]++, destroy)) && (cov_183vvehy76.b[60][2]++, !show) || (cov_183vvehy76.b[60][3]++, !this.parentElement) || (cov_183vvehy76.b[60][4]++, !children)) {
        cov_183vvehy76.b[59][0]++;
        cov_183vvehy76.s[164]++;
        return (
          /*#__PURE__*/
          React.createElement("noscript", {
            ref: this.placeholderRef,
            __self: this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 286,
              columnNumber: 14
            }
          })
        );
      } else {
        cov_183vvehy76.b[59][1]++;
      }

      cov_183vvehy76.s[165]++;
      this.isRendered = true;
      var colorStyle = (cov_183vvehy76.s[166]++, {
        background: background,
        borderColor: border
      });
      var innerStyle = (cov_183vvehy76.s[167]++, Object.assign({}, this.props.style, {
        background: background
      }));
      var position = (cov_183vvehy76.s[168]++, this.getPositionStr()); // eslint-disable-next-line

      var style = (cov_183vvehy76.s[169]++, this.element.style);
      cov_183vvehy76.s[170]++;

      if (show) {
        cov_183vvehy76.b[61][0]++;
        cov_183vvehy76.s[171]++;
        // 先隐藏再设置样式这样可以减少回流
        style.display = 'none';
        cov_183vvehy76.s[172]++;
        this.updatePosition(position);
        cov_183vvehy76.s[173]++;

        if (background) {
          cov_183vvehy76.b[62][0]++;
          cov_183vvehy76.s[174]++;
          style.background = background;
        } else {
          cov_183vvehy76.b[62][1]++;
        }

        cov_183vvehy76.s[175]++;

        if (border) {
          cov_183vvehy76.b[63][0]++;
          cov_183vvehy76.s[176]++;
          style.borderColor = border;
        } else {
          cov_183vvehy76.b[63][1]++;
        }

        cov_183vvehy76.s[177]++;
        style.display = 'block';
      } else {
        cov_183vvehy76.b[61][1]++;
        cov_183vvehy76.s[178]++;
        style.display = 'none';
      }

      cov_183vvehy76.s[179]++;
      this.element.className = classnames(popoverClass('_', position, type), this.props.className, this.id);
      var childrened = (cov_183vvehy76.s[180]++, isFunc(children) ? (cov_183vvehy76.b[64][0]++, children(this.handleHide)) : (cov_183vvehy76.b[64][1]++, children));
      cov_183vvehy76.s[181]++;

      if ((cov_183vvehy76.b[66][0]++, typeof childrened === 'string') || (cov_183vvehy76.b[66][1]++, useTextStyle)) {
        cov_183vvehy76.b[65][0]++;
        cov_183vvehy76.s[182]++;
        childrened =
        /*#__PURE__*/
        React.createElement("span", {
          className: popoverClass('text'),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 308,
            columnNumber: 20
          }
        }, childrened);
      } else {
        cov_183vvehy76.b[65][1]++;
      }

      cov_183vvehy76.s[183]++;
      return (
        /*#__PURE__*/
        ReactDOM.createPortal([(cov_183vvehy76.b[67][0]++, showArrow) && (cov_183vvehy76.b[67][1]++,
        /*#__PURE__*/
        React.createElement("div", {
          key: "arrow",
          className: popoverClass('arrow'),
          style: colorStyle,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 311,
            columnNumber: 22
          }
        })),
        /*#__PURE__*/
        React.createElement("div", {
          key: "content",
          onClick: emptyEvent,
          className: popoverClass('content'),
          style: innerStyle,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 312,
            columnNumber: 9
          }
        },
        /*#__PURE__*/
        React.createElement(Provider, {
          value: this.bindChain,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 313,
            columnNumber: 11
          }
        },
        /*#__PURE__*/
        React.createElement(ScrollProvider, {
          value: {
            element: undefined
          },
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 314,
            columnNumber: 13
          }
        },
        /*#__PURE__*/
        React.createElement(AbsoluteProvider, {
          value: false,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 315,
            columnNumber: 15
          }
        }, childrened))))], this.element)
      );
    }
  }]);

  return Panel;
}(Component);

Panel.defaultProps = DefaultProps;
export default consumer(Panel);